import { render } from "./info-person.vue?vue&type=template&id=63e5e4f4&scoped=true&ts=true"
import script from "./info-person.vue?vue&type=script&lang=ts"
export * from "./info-person.vue?vue&type=script&lang=ts"

import "./info-person.vue?vue&type=style&index=0&id=63e5e4f4&lang=less&scoped=true"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63e5e4f4"]])

export default __exports__